export default "__VITE_ASSET__5121ad78__"